// Aplica máscara de formatação apropriada enquanto o usuário digita

import { Directive } from '@angular/core';

@Directive({
  selector: 'input[matInput][slcDatepickerDateString]',
  standalone: true,
  host: { '(input)': 'onInput($event)', maxLength: '10' },
})
export class SliceDatepickerDateStringDirective {
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const formatted = this.formatarData(input.value);

    if (formatted) {
      input.value = formatted;
    }
  }

  /** Retorna data no formato DD/MM/YYYY */
  formatarData(inputValue: string): string | null {
    const regex = /^\d{2}\/\d{2}\/\d{4}$/;

    if (!regex.test(inputValue)) {
      const cleanedValue = inputValue.replace(/\D/g, '');

      const formattedValue = cleanedValue
        .slice(0, 8)
        .replace(/(\d{2})(\d)/, '$1/$2')
        .replace(/(\d{2})(\d)/, '$1/$2');

      return formattedValue;
    }

    return null;
  }
}
